import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrderSuccessModalPage } from './order-success-modal.page';

const routes: Routes = [
  {
    path: '',
    component: OrderSuccessModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderSuccessModalPageRoutingModule {}
